<template>
  <div>
    <v-dialog
        v-model="dialog"
        persistent
        class="station-edit"
        max-width="600"
        @close="$emit('close')"
    >
      <v-card v-if="loading">
        <v-card-text class="mt-0 pt-3">
          Loading...
          <v-progress-linear
              indeterminate
              color="primary"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
      <v-card v-else>
        <v-card-title>
          {{ unitIdentifier ? 'Edit Unit' : 'Create Unit'}}
        </v-card-title>
        <v-card-text class="dialog-v-text-scrollable">
          <v-alert
              v-if="errorAlert"
              type="error"
              outlined
              transition="scale-transition"
              class="mt-2"
          >
            {{ errorMessage }}
          </v-alert>
          <v-layout wrap>
            <v-flex xs12>
              <v-flex xs12>
                <v-autocomplete
                    v-model="unitData.type"
                    v-validate="{ required: true}"
                    :items="unitTypes"
                    :error-messages="errors.collect('type')"
                    label="Type"
                    name="type"
                />
              </v-flex>

              <v-text-field
                  v-model="unitData.staffing"
                  v-validate="{ required: true}"
                  :error-messages="errors.collect('staffing')"
                  label="Staffing"
                  name="staffing"
                  type="number"
                  @keydown="integerFilter"
              />
            </v-flex>

            <v-flex xs12>
              <v-checkbox
                  v-model="unitData.dedicatedStaffing"
                  :error-messages="errors.collect('dedicatedStaffing')"
                  label="Is the staffing dedicated?"
                  name="dedicatedStaffing"
              />
            </v-flex>

            <v-flex xs12>
              <v-text-field
                  v-model="unitData.cadDesignation1"
                  v-validate="{ required: true}"
                  :error-messages="errors.collect('cadDesignation1')"
                  label="Unit Name"
                  name="cadDesignation1"
              />
            </v-flex>

            <v-flex xs12>
              <v-text-field
                  v-model="unitData.cadDesignation2"
                  :error-messages="errors.collect('cadDesignation2')"
                  label="Alternate Unit Name"
                  name="cadDesignation2"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              color="blue darken-1"
              text
              @click.native="dialog = false"
          >Cancel</v-btn>
          <v-btn
              :loading="saving"
              color="primary"
              text
              @click.native="validateAndSave()"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import errorAlertMixins from '@/mixins/errorAlertMixins';
import neris from '@/api/neris';
import unitTypes from '@/components/Neris/Units/unitTypes';

export default {
  name: 'EditUnitPopup',
  mixins: [errorAlertMixins],
  data() {
    return {
      dialog: false,
      saving: false,
      loading: false,
      station: null,
      unitIdentifier: null,
      unitData: {
        staffing: null,
        dedicatedStaffing: false,
        type: null,
        cadDesignation1: null,
        cadDesignation2: null,
      },
      dictionary: {
        attributes: {
          staffing: 'Staffing',
          dedicatedStaffing: 'Dedicated Staffing',
          type: 'Type',
          cadDesignation1: 'Unit Name',
          cadDesignation2: 'Alternate Unit Name',
        },
      },
      unitTypes,
    };
  },
  mounted() {
    this.$validator.localize('en', this.dictionary);
  },
  methods: {
    async show(station, unitIdentifier = null, unitData = null) {
      try {
        this.loading = true;
        this.hideError();
        this.station = station;
        this.unitIdentifier = unitIdentifier;
        this.unitData = unitData || {
          staffing: null,
          dedicatedStaffing: false,
          type: null,
          cadDesignation1: null,
          cadDesignation2: null,
        };
        this.dialog = true;
      } finally {
        this.loading = false;
      }
    },
    async validateAndSave() {
      this.hideError();
      await this.$validator.reset();
      if (!await this.$validator.validateAll()) {
        return;
      }
      try {
        this.saving = true;
        if (this.unitIdentifier) {
          await neris.updateUnit(this.unitIdentifier, this.unitData);
        } else {
          await neris.createUnit(this.station.id, this.unitData);
        }
        this.$emit('saved');
        this.dialog = false;
      } catch (e) {
        this.parseErrorResponse(e.response, true);
      } finally {
        this.saving = false;
      }
    },

    integerFilter($event) {
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      const ignoreKeys = [8, 37, 39];
      if ((keyCode < 48 || keyCode > 57) && !ignoreKeys.includes(keyCode)) {
        $event.preventDefault();
      }
    },
  },
};
</script>
